import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { ERROR_OBJETIVOS } from "../../utils/uiText";
import { ERROR_REQUISITOS } from "../../utils/uiText";
import { ERROR_FUNCIONES } from "../../utils/uiText";

//------------- STATE -------------------------
const initialState = {
  //Obtener objetivo,funciones y requisitos sistema OPLE
  objetivos: [],
  funciones: [],
  requisitos: [],
  messageError: "",
  loading: false,
  //Obtener objetivo, funciones y requisitos sistema OPLE
  objetivoINE: [],
  funcionesINE: [],
  requisitosINE: [],
  //Link para obtener perfiles de cargos/puestos
  perfilesINE: null,
  perfilesOPLE: null,
};

const GET_OBJETIVO = "GET_OBJETIVO";
const GET_OBJETIVO_CLEAN = "GET_OBJETIVO_CLEAN";
const GET_OBJETIVO_ERROR = "GET_OBJETIVO_ERROR";
const GET_OBJETIVO_ERROR_SERVICE = "GET_OBJETIVO_ERROR_SERVICE";
const LOADING_OBJETIVO = "LOADING_OBJETIVO";

const GET_FUNCIONES = "GET_FUNCIONES";
const GET_FUNCIONES_CLEAN = "GET_FUNCIONES_CLEAN";
const GET_FUNCIONES_ERROR = "GET_FUNCIONES_ERROR";
const GET_FUNCIONES_ERROR_SERVICE = "GET_FUNCIONES_ERROR_SERVICE";
const LOADING_FUNCIONES = "LOADING_FUNCIONES";

const GET_REQUISITOS = "GET_REQUISITOS";
const GET_REQUISITOS_CLEAN = "GET_REQUISITOS_CLEAN";
const GET_REQUISITOS_ERROR = "GET_REQUISITOS_ERROR";
const GET_REQUISITOS_ERROR_SERVICE = "GET_REQUISITOS_ERROR_SERVICE";
const LOADING_REQUISITOS = "LOADING_REQUISITOS";

const GET_OBJETIVO_INE = "GET_OBJETIVO_INE";
const GET_OBJETIVO_INE_CLEAN = "GET_OBJETIVO_INE_CLEAN";
const GET_OBJETIVO_INE_ERROR = "GET_OBJETIVO_INE_ERROR";
const GET_OBJETIVO_INE_ERROR_SERVICE = "GET_OBJETIVO_INE_ERROR_SERVICE";
const LOADING_OBJETIVO_INE = "LOADING_OBJETIVO_INE";

const GET_FUNCIONES_INE = "GET_FUNCIONES_INE";
const GET_FUNCIONES_INE_CLEAN = "GET_FUNCIONES_INE_CLEAN";
const GET_FUNCIONES_INE_ERROR = "GET_FUNCIONES_INE_ERROR";
const GET_FUNCIONES_INE_ERROR_SERVICE = "GET_FUNCIONES_INE_ERROR_SERVICE";
const LOADING_FUNCIONES_INE = "LOADING_FUNCIONES_INE";

const GET_REQUISITOS_INE = "GET_REQUISITOS_INE";
const GET_REQUISITOS_INE_CLEAN = "GET_REQUISITOS_INE_CLEAN";
const GET_REQUISITOS_INE_ERROR = "GET_REQUISITOS_INE_ERROR";
const GET_REQUISITOS_INE_ERROR_SERVICE = "GET_REQUISITOS_INE_ERROR_SERVICE";
const LOADING_REQUISITOS_INE = "LOADING_REQUISITOS_INE";

const GET_PERFILES_INE = "[VACANTES] GET_PERFILES_INE";
const GET_PERFILES_OPLE = "[VACANTES] GET_PERFILES_OPLE";

//------------- REDUCER -------------------------
const descripcionPuestoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OBJETIVO:
      return {
        ...state,
        objetivos: action.payload,
        messageError: null,
      };
    case GET_OBJETIVO_ERROR:
      return {
        ...state,
        messageError: ERROR_OBJETIVOS,
        objetivos: [],
        loading: false,
      };
    case GET_OBJETIVO_ERROR_SERVICE:
      return {
        ...state,
        objetivos: [],
        loading: false,
        messageError: ERROR_OBJETIVOS,
      };
    case GET_OBJETIVO_CLEAN:
      return initialState;
    case LOADING_OBJETIVO:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_FUNCIONES:
      return {
        ...state,
        funciones: action.payload,
        messageError: null,
      };
    case GET_FUNCIONES_ERROR:
      return {
        ...state,
        messageError: ERROR_FUNCIONES,
        funciones: [],
        loading: false,
      };
    case GET_FUNCIONES_ERROR_SERVICE:
      return {
        ...state,
        funciones: [],
        loading: false,
        messageError: ERROR_FUNCIONES,
      };
    case GET_FUNCIONES_CLEAN:
      return initialState;
    case LOADING_FUNCIONES:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_REQUISITOS:
      return {
        ...state,
        requisitos: action.payload,
        messageError: null,
      };
    case GET_REQUISITOS_ERROR:
      return {
        ...state,
        messageError: ERROR_REQUISITOS,
        requisitos: [],
        loading: false,
      };
    case GET_REQUISITOS_ERROR_SERVICE:
      return {
        ...state,
        requisitos: [],
        loading: false,
        messageError: ERROR_REQUISITOS,
      };
    case GET_REQUISITOS_CLEAN:
      return initialState;
    case LOADING_REQUISITOS:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_OBJETIVO_INE:
      return {
        ...state,
        objetivoINE: action.payload,
        messageError: null,
      };
    case GET_OBJETIVO_INE_ERROR:
      return {
        ...state,
        messageError: ERROR_OBJETIVOS,
        objetivoINE: [],
        loading: false,
      };
    case GET_OBJETIVO_INE_ERROR_SERVICE:
      return {
        ...state,
        objetivoINE: [],
        loading: false,
        messageError: ERROR_OBJETIVOS,
      };
    case GET_OBJETIVO_INE_CLEAN:
      return initialState;
    case LOADING_OBJETIVO_INE:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_FUNCIONES_INE:
      return {
        ...state,
        funcionesINE: action.payload,
        messageError: null,
      };
    case GET_FUNCIONES_INE_ERROR:
      return {
        ...state,
        messageError: ERROR_FUNCIONES,
        funcionesINE: [],
        loading: false,
      };
    case GET_FUNCIONES_INE_ERROR_SERVICE:
      return {
        ...state,
        funcionesINE: [],
        loading: false,
        messageError: ERROR_FUNCIONES,
      };
    case GET_FUNCIONES_INE_CLEAN:
      return initialState;
    case LOADING_FUNCIONES_INE:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_REQUISITOS_INE:
      return {
        ...state,
        requisitosINE: action.payload,
        messageError: null,
      };
    case GET_REQUISITOS_INE_ERROR:
      return {
        ...state,
        messageError: ERROR_REQUISITOS,
        requisitosINE: [],
        loading: false,
      };
    case GET_REQUISITOS_INE_ERROR_SERVICE:
      return {
        ...state,
        requisitosINE: [],
        loading: false,
        messageError: ERROR_REQUISITOS,
      };
    case GET_PERFILES_INE:
      return { ...state, perfilesINE: action.payload };

    case GET_PERFILES_OPLE:
      return {
        ...state,
        perfilesOPLE: action.payload,
      };

    case GET_REQUISITOS_INE_CLEAN:
      return initialState;
    case LOADING_REQUISITOS_INE:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};
export default descripcionPuestoReducer;

//------------- ACTIONS ------------------------------------------

//------------------------OPLE--------------------------------------------

export const setLoadingObjetivo = (status) => ({
  type: LOADING_OBJETIVO,
  payload: status,
});
export const setLoadingFunciones = (status) => ({
  type: LOADING_FUNCIONES,
  payload: status,
});

export const setLoadingRequisitos = (status) => ({
  type: LOADING_REQUISITOS,
  payload: status,
});

export const cleanObjetivos = () => (dispatch) => {
  dispatch({
    type: GET_OBJETIVO_CLEAN,
  });
};
export const cleanFunciones = () => (dispatch) => {
  dispatch({
    type: GET_FUNCIONES_CLEAN,
  });
};
export const cleanRequisitos = () => (dispatch) => {
  dispatch({
    type: GET_REQUISITOS_CLEAN,
  });
};

//------------------------INE--------------------------------------------

export const setLoadingObjetivoINE = (status) => ({
  type: LOADING_OBJETIVO_INE,
  payload: status,
});
export const setLoadingFuncionesINE = (status) => ({
  type: LOADING_FUNCIONES_INE,
  payload: status,
});
export const setLoadingRequisitosINE = (status) => ({
  type: LOADING_REQUISITOS_INE,
  payload: status,
});

export const cleanObjetivosINE = () => (dispatch) => {
  dispatch({
    type: GET_OBJETIVO_INE_CLEAN,
  });
};
export const cleanFuncionesINE = () => (dispatch) => {
  dispatch({
    type: GET_FUNCIONES_INE_CLEAN,
  });
};
export const cleanRequisitosINE = () => (dispatch) => {
  dispatch({
    type: GET_REQUISITOS_INE_CLEAN,
  });
};

export const linkPerfilesINE = (state) => ({
  type: GET_PERFILES_INE,
  payload: state,
});

export const linkPerfilesOPLE = (state) => ({
  type: GET_PERFILES_OPLE,
  payload: state,
});

export const getObjetivos = (idCargoPuesto) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerObjetivo}`,
      { idCargoPuesto },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({
      type: GET_OBJETIVO,
      payload: response.data,
    });
    dispatch(setLoadingObjetivo(false));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_OBJETIVO_ERROR_SERVICE,
      });
    } else {
      dispatch({
        type: GET_OBJETIVO_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const getFunciones = (idCargoPuesto) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerFunciones}`,
      { idCargoPuesto },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({
      type: GET_FUNCIONES,
      payload: response.data,
    });
    dispatch(setLoadingFunciones(false));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_FUNCIONES_ERROR_SERVICE,
      });
    } else {
      dispatch({
        type: GET_FUNCIONES_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const getRequisitos = (idCargoPuesto) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerRequisitos}`,
      { idCargoPuesto },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({
      type: GET_REQUISITOS,
      payload: response.data,
    });
    dispatch(setLoadingRequisitos(false));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_REQUISITOS_ERROR_SERVICE,
      });
    } else {
      dispatch({
        type: GET_REQUISITOS_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const getObjetivoINE = (idTipoCargoPuesto) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerObjetivoINE}`,
      { idTipoCargoPuesto },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({
      type: GET_OBJETIVO_INE,
      payload: response.data,
    });
    dispatch(setLoadingObjetivoINE(false));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_OBJETIVO_INE_ERROR_SERVICE,
      });
    } else {
      dispatch({
        type: GET_OBJETIVO_INE_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const getRequisitosINE = (idTipoCargoPuesto) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerRequisitosINE}`,
      { idTipoCargoPuesto },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({
      type: GET_REQUISITOS_INE,
      payload: response.data,
    });

    dispatch(setLoadingRequisitosINE(false));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_REQUISITOS_INE_ERROR_SERVICE,
      });
    } else {
      dispatch({
        type: GET_REQUISITOS_INE_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const getFuncionesINE = (idTipoCargoPuesto) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const response = await axios.post(
      `${urls.data.urlServer}${urls.data.urlObtenerFuncionesINE}`,
      { idTipoCargoPuesto },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({
      type: GET_FUNCIONES_INE,
      payload: response.data,
    });
    dispatch(setLoadingFuncionesINE(false));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_FUNCIONES_INE_ERROR_SERVICE,
      });
    } else {
      dispatch({
        type: GET_FUNCIONES_INE_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const PerfilesINE = () => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlLinkPerfilesINE}`
    );
    dispatch(linkPerfilesINE(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_PERFILES_INE,
      });
    } else {
      dispatch({
        type: GET_OBJETIVO_ERROR,
        payload: error.response.data,
      });
    }
  }
};

export const PerfilesOPLE = () => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    const { data } = await axios.post(
      `${urls.data.urlServer}${urls.data.urlLinkPerfilesOPLE}`
    );
    dispatch(linkPerfilesOPLE(data));
  } catch (error) {
    if (!error.response) {
      dispatch({
        type: GET_PERFILES_OPLE,
      });
    } else {
      dispatch({
        type: GET_OBJETIVO_ERROR,
        payload: error.response.data,
      });
    }
  }
};
